import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { selector as commonSelector } from '@store/common';
import { applyFilter } from '@store/common/actions';
import { selector as filterContainerSelector } from '@store/filterContainer';
import {
  changeFilterContainerVisibility,
  getFilters,
  updateActiveTab,
  updateSelectedFilters,
} from '@store/filterContainer/actions';

import FilterContainer from './FilterContainer';

const selector = createSelector(
  filterContainerSelector,
  commonSelector,
  // eslint-disable-next-line max-len
  (filterContainer, common, router, userRole) => ({
    activeTabKey: filterContainer.activeTabKey,
    type: filterContainer.type,
    filters: filterContainer.filters,
    defaultFilters: filterContainer.defaultFilters,
    appliedFilters: common.appliedFilters,
    features: common.features,
    selectedFilters: filterContainer.savedFilterPanel.selectedFilters,
    compareMode: common.compareMode,
    router,
    modal: common.modal,
    userRole,
  }),
);

export default connect(selector, {
  updateActiveTab,
  getFilters,
  applyFilter,
  updateSelectedFilters,
  changeFilterContainerVisibility,
})(FilterContainer);
